<template>
  <div class="client-portal-user-status">
    <div v-if="store.isLoggedIn" class="user-status-authenticated">
      <div class="user-info">
        <div class="user-avatar">
          <i class="fas fa-user-circle"></i>
        </div>
        <div class="user-details">
          <div class="signed-in-label">Signed in as</div>
          <div class="user-name">{{ store.clientInfo.user.name }}</div>
        </div>
      </div>
      <button @click="store.logout()" class="logout-link" title="Sign Out" :disabled="store.advisorView">
        <i class="fas fa-sign-out-alt"></i>
      </button>
    </div>

    <div v-else class="user-status-unauthenticated">
      <div class="user-avatar">
        <i class="fas fa-user"></i>
      </div>
      <span>Not signed in</span>
      <button @click="store.login()" class="login-link" title="Sign In" :disabled="store.advisorView">
        Sign In
      </button>
    </div>
  </div>
</template>

<script setup>
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';
const store = useClientPortalStore();
</script>

<style scoped>
.client-portal-user-status {
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  flex-shrink: 0;
  margin: -0.75rem;
  margin-top: 0;
  padding-top: 1rem;
  flex-direction: column;
  border-top: 1px solid var(--stk-text-90);
}

/* Authenticated Status */
.user-status-authenticated {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0; /* Allow text to truncate */
}

.user-avatar {
  color: var(--stk-text-weak);
  font-size: 1.25rem;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-details {
  min-width: 0; /* Allow text to truncate */
  flex: 1;
  line-height: 1.3;
}

.signed-in-label {
  font-size: 0.75rem;
  color: var(--stk-text-weak);
  margin-bottom: 0.125rem;
  display: block;
}

.user-name {
  font-weight: 600;
  color: var(--stk-text-strong);
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-link {
  color: var(--stk-text-weak);
  font-size: 1.125rem;
  padding: 0.375rem;
  transition: color 0.2s ease;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  flex-shrink: 0;
}

.logout-link:hover {
  color: #dc2626;
  background: rgba(220, 38, 38, 0.05);
}

/* Unauthenticated Status */
.user-status-unauthenticated {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  gap: 0.5rem;
}

.login-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
  margin-left: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
}

.login-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.user-icon-gray {
  opacity: 0.6;
}
</style>
